import React from 'react'
import PropTypes from 'prop-types'
import { Route as ReactRouterRoute } from 'react-router'
import { connect } from 'react-redux'
import pick from '../utilities/pick'

class Route extends React.Component {
	render() {
		const { component, componentProps, ...rest } = this.props
		const Component = component
		return (
			<ReactRouterRoute
				{...rest}
				render={
					routerProps => <Component {...{ ...routerProps, ...componentProps }} />
				}
			/>
		)
	}
}

Route.propTypes = {
	component: PropTypes.func.isRequired,
	componentProps: PropTypes.object // eslint-disable-line react/forbid-prop-types
}

Route.defaultProps = {
	componentProps: {}
}

export const testing = {
	Route
}

export default connect(
	/* istanbul ignore next line */
	state => pick(state, ['user']),
	/* istanbul ignore next line */
	null
)(Route)



// WEBPACK FOOTER //
// ./src/components/Route.jsx